var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 40,
    viewBox: "0 0 82 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1715 9.94789C56.0051 9.4974 54.1551 9 51.8676 9C46.0278 9 41.9155 12.0316 41.8902 16.3659C41.8417 19.5638 44.8345 21.3399 47.0729 22.4062C49.3608 23.4957 50.1385 24.2069 50.1385 25.1781C50.1152 26.6696 48.2898 27.3572 46.5872 27.3572C44.2263 27.3572 42.9613 27.0027 41.0388 26.1729L40.2601 25.8171L39.4326 30.8151C40.8196 31.4302 43.3748 31.9761 46.0278 32C52.2327 32 56.2722 29.0153 56.3201 24.3964C56.3437 21.8619 54.7634 19.9198 51.3563 18.3329C49.288 17.3141 48.0214 16.6272 48.0214 15.5849C48.0456 14.6373 49.0927 13.6667 51.4275 13.6667C53.3499 13.6192 54.7624 14.0691 55.8324 14.5192L56.3673 14.7557L57.1715 9.94789ZM35.7348 31.6682H29.8213L33.52 9.40358H39.4332L35.7348 31.6682ZM67.3919 17.5512C67.3919 17.5512 65.518 22.5016 65.031 23.7806H69.9463C69.7031 22.6675 68.5833 17.338 68.5833 17.338L68.17 15.4196C67.9961 15.9132 67.7446 16.5918 67.5749 17.0499L67.5746 17.0508L67.5745 17.0509L67.5745 17.0511C67.4594 17.3615 67.382 17.5704 67.3919 17.5512ZM67.7564 9.40358H72.3305L77.1012 31.6679H71.6259C71.6259 31.6679 71.09 29.1097 70.9203 28.3281H63.3278C63.1082 28.9199 62.0867 31.6679 62.0867 31.6679H55.8818L64.6656 11.2509C65.2742 9.80591 66.3458 9.40358 67.7564 9.40358ZM24.8822 9.40358L19.0909 24.5859L18.458 21.5068C18.4578 21.506 18.4576 21.5052 18.4573 21.5044L16.3897 11.2751C16.0492 9.85313 15.0028 9.45049 13.7132 9.40358H4.1989L4.10156 9.85344C6.42208 10.4311 8.49757 11.2636 10.3161 12.2986L15.5868 31.6446H21.8402L31.1352 9.40358H24.8822Z",
    fill: "#2D2926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 23,
    fill: "white",
    transform: "translate(4.10156 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterVisa);
export default __webpack_public_path__ + "static/media/footer-visa.5e64113e68a3e50ca231df91f88773bf.svg";
export { ForwardRef as ReactComponent };